<template>
    <div ref="div" class="sidebar-toggle"  @click="dispatchState">
        <button>Toggle the story sidebar</button>
    </div>
</template>

<script>

    import { mapState } from 'vuex';
    import { 
        select as d3Select,
    } from 'd3';

    export default {
        name: 'SidebarToggle',
        props: ['pos', 'visible'],
        computed: {
            ...mapState(['sidebarVisible']),
        },
        data() {
            return {
                container: null
            }
        },
        methods: {
            dispatchState() {
                const state = this.sidebarVisible == this.pos ? 'none' : this.pos;
                this.$store.dispatch("SET_SIDEBAR_VISIBLE", state);
            }
        },
        mounted() {
            this.container = d3Select(this.$refs.div)
            this.container.classed(this.pos, true)
        }
    }
</script>

<style lang="scss">
    @import '../assets/style/main.scss';
    
    .sidebar {

        &-toggle {
            position: absolute;
            z-index: 10;
            top: 50px;
            cursor: pointer;
            transition: all $time-m ease-in-out;

            &.right {
                right: 50px;
                &.active {
                    right: $sidebar-width + 20;
                }
            }

            &.left {
                left: 50px;
                &.active {
                    left: $sidebar-width + 20;
                }
            }


        }

    }
</style>


